// extracted by mini-css-extract-plugin
module.exports = {"AnonMenu":"AnonMenu-module_AnonMenu_1p406","login":"AnonMenu-module_login_2bBt3","fadeOut":"AnonMenu-module_fadeOut_1sRhG","register":"AnonMenu-module_register_2apap"};